var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBotAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8509_5692)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#830070"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H15C13.8954 15 13 15.8954 13 17V27C13 28.1046 13.8954 29 15 29H25C26.1046 29 27 28.1046 27 27V17C27 15.8954 26.1046 15 25 15Z",
    stroke: "url(#paint0_linear_8509_5692)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19H29C29.5523 19 30 19.4477 30 20V24C30 24.5523 29.5523 25 29 25H27",
    stroke: "url(#paint1_linear_8509_5692)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25H11C10.4477 25 10 24.5523 10 24V20C10 19.4477 10.4477 19 11 19H13",
    stroke: "url(#paint2_linear_8509_5692)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 10.5C21.5 11.3284 20.8284 12 20 12C19.1716 12 18.5 11.3284 18.5 10.5C18.5 9.67157 19.1716 9 20 9C20.8284 9 21.5 9.67157 21.5 10.5Z",
    stroke: "url(#paint3_linear_8509_5692)",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12V15",
    stroke: "url(#paint4_linear_8509_5692)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19V20",
    stroke: "url(#paint5_linear_8509_5692)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19V20",
    stroke: "url(#paint6_linear_8509_5692)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24C18 24 18.6667 24.5 20 24.5C21.3333 24.5 22 24 22 24",
    stroke: "url(#paint7_linear_8509_5692)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8509_5692",
    x: 0,
    y: -16.625,
    width: 40,
    height: 56.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.3125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6375 0 0 0 0 0.00796875 0 0 0 0 0.543319 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8509_5692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8509_5692",
    x1: 20,
    y1: 15,
    x2: 20,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8509_5692",
    x1: 28.5,
    y1: 19,
    x2: 28.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8509_5692",
    x1: 11.5,
    y1: 19,
    x2: 11.5,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8509_5692",
    x1: 20,
    y1: 9,
    x2: 20,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8509_5692",
    x1: 20.5,
    y1: 12,
    x2: 20.5,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8509_5692",
    x1: 17.5,
    y1: 19,
    x2: 17.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8509_5692",
    x1: 23.5,
    y1: 19,
    x2: 23.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8509_5692",
    x1: 20,
    y1: 24,
    x2: 20,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotAvatar);
export default __webpack_public_path__ + "static/media/bot_avatar.2781e28aa2945e41cd28c984c5643537.svg";
export { ForwardRef as ReactComponent };